import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

import backendService from '../services/backendService';

interface EventTrackingOptions {
  retry?: number;
  retryDelay?: number;
}

export const useAttioEventTracking = (options: EventTrackingOptions = {}) => {
  const { retry = 3, retryDelay = 2000 } = options;

  const { mutate: trackEventMutation } = useMutation({
    mutationFn: ({
      eventName,
      payload,
    }: {
      eventName: string;
      payload?: { [key: string]: unknown };
    }) => backendService.instance.events.trackEvent(eventName, payload),

    retry,
    retryDelay,

    onError: (error: any) => {
      // Silently log the error without throwing or showing to user
      console.error(`Error tracking event:`, error);
    }
  });

  const trackEvent = useCallback(
    (eventName: string, payload?: { [key: string]: unknown }) => {
      trackEventMutation({ eventName, payload });
    },
    [trackEventMutation],
  );

  return trackEvent;
};

export default useAttioEventTracking;
